import "gatsby-remark-vscode/styles.css";

import Wrapper from "./src/root";

export const wrapRootElement = Wrapper;
